export const PAYABLES_SHEET_NAME = "Payables";
export const PAYABLES_SHEET_SLUG = PAYABLES_SHEET_NAME.toLowerCase();

// Server-side v3 payables importer (flatfile-platform `payablesImport`, WIN-15867)
export const BULK_IMPORT_PAYABLES_IMPORT_NAMESPACE = "payablesImport";
export const PAYABLES_IMPORT_ACTION_SLUG = "finalize-payablesImport";

export const CONTRACTORS_SHEET_NAME = "Contractors";
export const CONTRACTORS_SHEET_SLUG = CONTRACTORS_SHEET_NAME.toLowerCase();

export const OLD_BULK_BATCHES_THRESHOLD_IN_DAYS = 14;

export const BULK_BATCH_EVENT_HISTORY_START_DATE = "2025-03-10";

/** Batch metadata key holding the number of rows the Flatfile listener could not upload. */
export const FLATFILE_REJECTED_ROWS_COUNT_METADATA_KEY =
  "flatfileRejectedRowsCount";

/** How often the Flatfile upload job is polled while an upload is in progress. */
export const FLATFILE_UPLOAD_JOB_REFETCH_INTERVAL = 5000;

/** How often batch progress is polled while an import is running. */
export const IMPORT_PROGRESS_REFETCH_INTERVAL = 2000;
